import { render } from "./TermsConditions.vue?vue&type=template&id=44b1d2c8&scoped=true"
import script from "./TermsConditions.vue?vue&type=script&lang=js"
export * from "./TermsConditions.vue?vue&type=script&lang=js"

import "./TermsConditions.vue?vue&type=style&index=0&id=44b1d2c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b1d2c8"]])

export default __exports__